import React, { useState } from "react";

const InterviewGyneA1 = ({ onClose, shareUrl, shareTitle, shareText }) => {
  const [showShareMenu, setShowShareMenu] = useState(false);

  const handleShareClick = (platform) => {
    const url = shareUrl || window.location.href;
    const title = shareTitle || "Interview with Gynecologist";
    const text = shareText || "Read this interview about gynecological health.";

    if (platform === "whatsapp") {
      window.open(`https://wa.me/?text=${encodeURIComponent(text + " " + url)}`);
    } else if (platform === "email") {
      window.location.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(text + "\n\n" + url)}`;
    } else if (platform === "copy") {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          alert("Link copied to clipboard!");
        }).catch(() => {
          fallbackCopy(url);
        });
      } else {
        fallbackCopy(url);
      }
    }
    setShowShareMenu(false);
  };

  const fallbackCopy = (text) => {
    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert("Link copied to clipboard!");
    } catch (e) {
      alert("Could not copy link. Please copy manually: " + text);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        zIndex: 9999,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        overflowY: "auto",
        paddingTop: 20,
        paddingBottom: 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 10,
          padding: 24,
          minWidth: 320,
          maxWidth: 700,
          width: "94%",
          boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
          position: "relative",
          margin: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            background: "none",
            border: "none",
            fontSize: 24,
            color: "#8e44ad",
            cursor: "pointer",
            padding: 0,
            width: 36,
            height: 36,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          title="Close"
        >
          ✕
        </button>

        <h1 style={{ color: "#8e44ad", fontSize: "1.1rem", marginTop: 0, marginBottom: 16 }}>
          Interview with Gynecologist
        </h1>

        <div style={{ color: "#222", lineHeight: 1.5 }}>
          <p style={{ marginTop: 0, marginBottom: 12, fontSize: "0.90rem", fontWeight: 600 }}>
            <strong>Interviewer:</strong> Dr. Sharma, thank you for joining us today! Gynecological issues are something many women experience but don’t always talk about. What are some of the most common problems you see?
          </p>

          <p style={{ marginTop: 0, marginBottom: 12, fontSize: "0.90rem" }}>
            <strong>Dr. Sharma:</strong> Thank you for having me! I often see menstrual irregularities, PCOS, vaginal infections, pelvic pain, fibroids, fertility concerns, and menopause-related symptoms. Many women quietly struggle with these, so open conversations are important.
          </p>

          <p style={{ marginTop: 12, marginBottom: 12, fontSize: "0.90rem", fontWeight: 600 }}>
            <strong>Interviewer:</strong> PCOS seems very common nowadays. Why is that?
          </p>

          <p style={{ marginTop: 0, marginBottom: 12, fontSize: "0.90rem" }}>
            <strong>Dr. Sharma:</strong> PCOS is increasing, especially among young women. Stress, lack of exercise, poor sleep, and diets high in processed foods contribute. Genetics also plays a role. It’s not just a reproductive issue—it affects hormones, metabolism, and long-term health.
          </p>

          <p style={{ marginTop: 12, marginBottom: 12, fontSize: "0.90rem", fontWeight: 600 }}>
            <strong>Interviewer:</strong> What symptoms should women never ignore?
          </p>

          <p style={{ marginTop: 0, marginBottom: 12, fontSize: "0.90rem" }}>
            <strong>Dr. Sharma:</strong> Irregular or heavy periods, severe cramps, persistent pelvic pain, unusual discharge, bleeding between periods, pain during intercourse, difficulty conceiving, sudden weight gain, or excess hair growth. These signs should be checked promptly.
          </p>

          <p style={{ marginTop: 12, marginBottom: 12, fontSize: "0.90rem", fontWeight: 600 }}>
            <strong>Interviewer:</strong> Many women feel shy talking about vaginal infections. What should they know?
          </p>

          <p style={{ marginTop: 0, marginBottom: 12, fontSize: "0.90rem" }}>
            <strong>Dr. Sharma:</strong> Infections are extremely common—yeast infections, bacterial vaginosis, and UTIs happen to women of all ages. Symptoms like itching, burning, unusual odor, or discharge should be evaluated. Self-medicating can sometimes worsen things—better to get a proper diagnosis.
          </p>

          <p style={{ marginTop: 12, marginBottom: 12, fontSize: "0.90rem", fontWeight: 600 }}>
            <strong>Interviewer:</strong> What lifestyle habits help maintain good reproductive health?
          </p>

          <p style={{ marginTop: 0, marginBottom: 12, fontSize: "0.90rem" }}>
            <strong>Dr. Sharma:</strong> Maintain a healthy weight, eat a balanced diet, stay active, practice safe sex, avoid harsh soaps or douching, manage stress, and go for regular check-ups. Small daily habits create long-term health benefits.
          </p>

          <p style={{ marginTop: 12, marginBottom: 12, fontSize: "0.90rem", fontWeight: 600 }}>
            <strong>Interviewer:</strong> When should someone get a gynecological exam?
          </p>

          <p style={{ marginTop: 0, marginBottom: 12, fontSize: "0.90rem" }}>
            <strong>Dr. Sharma:</strong> Ideally once a year. Pap smears starting at age 21 (depending on guidelines), routine breast exams, ultrasounds when needed, and a visit anytime something feels unusual. Preventive care is very powerful.
          </p>

          <p style={{ marginTop: 12, marginBottom: 12, fontSize: "0.90rem", fontWeight: 600 }}>
            <strong>Interviewer:</strong> Many women push through menstrual pain. When is it a concern?
          </p>

          <p style={{ marginTop: 0, marginBottom: 12, fontSize: "0.90rem" }}>
            <strong>Dr. Sharma:</strong> Mild cramps are normal. But if pain stops you from daily activities or keeps you in bed, conditions like endometriosis or fibroids may be the cause. Early treatment greatly improves quality of life.
          </p>

          <p style={{ marginTop: 12, marginBottom: 12, fontSize: "0.90rem", fontWeight: 600 }}>
            <strong>Interviewer:</strong> What about menopause? Many women worry about it.
          </p>

          <p style={{ marginTop: 0, marginBottom: 12, fontSize: "0.9rem" }}>
            <strong>Dr. Sharma:</strong> Menopause is natural, but symptoms like hot flashes, mood swings, and sleep issues can be challenging. Lifestyle changes and sometimes medical support can help. Women don’t need to suffer silently—many solutions exist.
          </p>

          <p style={{ marginTop: 12, marginBottom: 12, fontSize: "0.90rem", fontWeight: 600 }}>
            <strong>Interviewer:</strong> Before we wrap up, what message would you give women about their reproductive health?
          </p>

          <p style={{ marginTop: 0, marginBottom: 12, fontSize: "0.90rem" }}>
            <strong>Dr. Sharma:</strong> Listen to your body. Don't normalize pain or discomfort. And please don't feel embarrassed—gynecologists are here to help, not judge. Your health deserves attention.
          </p>

          <div style={{ marginTop: 20, paddingTop: 16, borderTop: "1px solid #ddd", display: "flex", gap: "1rem", alignItems: "center", position: "relative" }}>
            <div style={{ position: "relative" }}>
              <button
                onClick={(e) => { e.stopPropagation(); setShowShareMenu(!showShareMenu); }}
                style={{
                  background: "#8e44ad",
                  color: "#fff",
                  border: "none",
                  padding: "8px 12px",
                  borderRadius: 4,
                  cursor: "pointer",
                  fontSize: "0.75rem",
                  minWidth: "auto",
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
                title="Share"
              >
                <span style={{ lineHeight: 1 }}>Share</span>
                <span style={{ fontSize: "0.8rem", opacity: 0.9 }}>▾</span>
              </button>

              {showShareMenu && (
                <div
                  style={{
                    position: "absolute",
                    bottom: "100%",
                    left: 0,
                    background: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: 4,
                    boxShadow: "0 -2px 8px rgba(0,0,0,0.15)",
                    marginBottom: 8,
                    minWidth: 140,
                    zIndex: 10,
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button onClick={() => handleShareClick("whatsapp")} style={{ display: "block", width: "100%", background: "none", border: "none", padding: "8px 12px", textAlign: "left", cursor: "pointer", fontSize: "0.75rem", borderBottom: "1px solid #eee", color: "#25D366", fontWeight: 500 }}>WhatsApp</button>
                  <button onClick={() => handleShareClick("email")} style={{ display: "block", width: "100%", background: "none", border: "none", padding: "8px 12px", textAlign: "left", cursor: "pointer", fontSize: "0.75rem", borderBottom: "1px solid #eee", color: "#333" }}>Email</button>
                  <button onClick={() => handleShareClick("copy")} style={{ display: "block", width: "100%", background: "none", border: "none", padding: "8px 12px", textAlign: "left", cursor: "pointer", fontSize: "0.75rem", color: "#333" }}>Copy Link</button>
                </div>
              )}
            </div>

            <div style={{ fontSize: "0.85rem", color: "#999" }}>
              <p style={{ margin: 0 }}>Dr. Sheha is a leading Gynecologist with 15 years of experience in obstetrics and regenerative medicine.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewGyneA1;
